import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const archiveServiceType = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/service-types/${_id}/archive`);
};

type UseArchiveServiceTypeOptions = {
  config?: MutationConfig<typeof archiveServiceType>;
};

const TOAST_ID = 'archive-service-type';

export const useArchiveServiceType = ({ config = {} }: UseArchiveServiceTypeOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['service-types']);
      toasts.loadingToast.success(TOAST_ID, 'Service type archived');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Archiving...');
      config.onMutate?.(...args);
    },
    mutationFn: archiveServiceType,
  });
};
